import { createAction } from '@reduxjs/toolkit'
import { Patient } from '../../types'

export type EhrAcquisitionOrigin = 'fresh' | 'restoring' | 'restarting' | 'focus'

export const ehrLaunchEstablished = createAction<{
  launchInstanceId: string
  origin: EhrAcquisitionOrigin
  reset: boolean
}>('ehrPatientAcquisition/launchEstablished')

export const ehrPatientBound = createAction<{
  launchInstanceId: string
  patient: Patient
}>('ehrPatientAcquisition/patientBound')

export const ehrPatientInvalidated = createAction('ehrPatientAcquisition/patientInvalidated')

export const ehrPatientAcquisitionCleared = createAction('ehrPatientAcquisition/cleared')
